import withReducer from '../../store/withReducer'
import TeamMemberInvite from './container'
import reducer from './module'

export default withReducer('teamMemberInvite', reducer)(TeamMemberInvite)



// WEBPACK FOOTER //
// ./src/legacy/pages/TeamMemberInvite/index.js